import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../action/ActionArgs'

@InputType()
export class MoveLogisticServiceArgs extends ActionArgs {
  @Field(() => String)
  sourceLogisticId: string
}
